import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { Chip, Button, Stack } from "@mui/material";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const getStatusColor = (status) => {
  switch (status) {
    case "approved":
      return "success";
    case "pending":
      return "warning";
    case "rejected":
      return "error";
    default:
      return "default";
  }
};

export default function data({ timeOffs = [], onApprove, onReject, onImageClick, t }) {
 

  const rows = timeOffs.map((timeOff) => {
    return {
      type: t(timeOff?.request),
      user: timeOff.user.name,
      date: timeOff.date,
      image: timeOff.imageUrl ? (
        <img 
          src={timeOff.imageUrl} 
          width={300} 
          height={300}
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "8px",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            transition: "transform 0.3s ease-in-out",
          }}
          onClick={() => onImageClick(timeOff.imageUrl)}
        />
      ) : (
        "Not provided"
      ),
      note: timeOff.note,
      action: (
        <Stack direction="row" spacing={1}>
          <MDButton variant="text" color="success" onClick={() => onApprove(timeOff.id)}>
            Approve
          </MDButton>
          <MDButton variant="text" color="primary" onClick={() => onReject(timeOff.id)}>
            Reject
          </MDButton>
        </Stack>
      ),
    };
  });

  return {
    columns: [
      { Header: "Type", accessor: "type", align: "left" },
      { Header: "User", accessor: "user", align: "left" },
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Image", accessor: "image", align: "left" },
      { Header: "Note", accessor: "note", align: "left" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
    rows: rows,
  };
}
